import { useEffect, useMemo, useId } from 'react'

import RSelect, { components } from 'react-select'
import kebabCase from 'lodash/kebabCase'

// Partials
import { InputValidationError } from "../partials/input-validation-error";
import Icon from "../../icon";
import { InputLabel } from "../partials/input-label";

const filterFunction = ( option, search ) => {
	let searchText = kebabCase(search);
	let matches = false;

	const lookup = (option, level = 1) => {
		for(const key in option) {
			let val = option[key];
			if(typeof val === 'string') {
				if (kebabCase(val).search(searchText) !== -1) { matches = true; }
			}
			else if(typeof val === 'number') {
				if (kebabCase(val.toString()).search(searchText) !== -1) { matches = true; }
			}
			else if(level < 3 && typeof val === 'object' && !Array.isArray(val)) {
				lookup(val, level + 1);
			}
		}
	}

	lookup(option);
	return matches;
}

const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<Icon name="angle-down" />
		</components.DropdownIndicator>
	);
};

const Control = ({ className, ...props }) => {
	return (
		<components.Control className={`inputwrap-input${props.isDisabled ? ' input-disabled' : ''} ${className || ''}`} {...props} />
	);
};

const IndicatorSeparator = () => ( null );

const SelectInput = ({
	onChangePlainValue, onChange, initialized,
	className, label, validationError,
	searchable, value, disabled, innerContent,
	...props
}) => {

	// const inputRef = useRef();

	const plainValue = useMemo(() => {
		return value?.value ? value?.value.toString() : '';
	}, [value])

	const elemId = useMemo(() => ( props.id ?? useId() ), [props.id])

	useEffect(() => {
		onChangePlainValue(plainValue);
	}, [plainValue])

	const {  ...computedProps } = useMemo(() => {
		let computedProps = {
			...props,
			styles: new Proxy({}, {
				get: () => () => {},
			}),
			className: 'tla-select-container',
			classNamePrefix: 'select',
			theme: false,
			isSearchable: searchable,
			isDisabled: disabled,
			id: elemId,
			instanceId: elemId,
			noOptionsMessage: () => ( props.noOptionsMessage ),
		}

		if(searchable) {
			computedProps.filterOption = filterFunction;
		}

		return computedProps;
	}, [searchable, props, disabled, elemId])

	const handleChange = newVal => {
		onChange(newVal);
	}

	return (
		<div className={className}>
			<InputLabel label={label} name={props.id} />
			<div className="inputwrap-innerwrap">
				{innerContent}
				<RSelect
					value={value}
					onChange={handleChange}
					components={{
						DropdownIndicator,
						Control,
						IndicatorSeparator,
					}}
					{...computedProps} />
			</div>
			<InputValidationError error={validationError} />
		</div>
	)
}

SelectInput.defaultProps = {
	searchable: false,
	placeholder: 'Seçiniz...',
	openMenuOnFocus: true,
	noOptionsMessage: 'Seçenek yok.'
}

export default SelectInput;